// extracted by mini-css-extract-plugin
export default {"balance":"TokenInput_balance__3JEZo","disabled":"TokenInput_disabled__zv71W"};